<template>
    <div class="project-detail">
        <Slider
            :slider="layout"
            :idx="idx"
            v-if="layout.slides"
            class="project-slider"
        >
        </Slider>
        <FollowUp>
            <template v-slot:main>
                <Ui
                    :slider="layout"
                    :idx="idx"
                    @next="next"
                    @previous="previous"
                >
                    <div class="context-decorator">
                        <div class="context-view">
                            <div class="context-headline">
                                <div class="context-caption">{{$t('common.context')}}</div>
                            </div>
                        </div>
                        <div class="context-headline dark">
                            <div class="context-caption">{{$t('common.context')}}</div>
                        </div>
                    </div>
                </Ui>
                <div class="sizer">
                    <p class="context">{{$parent.page.context}}</p>
                </div>
                <div class="footer main-footer">
                    <div class="gabarit">
                        <Cta
                            v-if="document"
                            :type="'a'"
                            :href="document"
                            download
                            class="link"
                            icon="icon-download"
                            target="_BLANK"
                            :colors="{ hover: { background: '#114991' } }"
                        >
                            {{$t('cta.download.document')}}
                        </Cta>
                    </div>
                </div>
            </template>
            <template v-slot:details>
                <div class="heading">
                    <div class="row" v-if="country">
                        <span class="headline">{{location ? $t('common.location') : $t('common.country')}}</span>
                        <p class="value" v-html="location || country.name"></p>
                    </div>
                    <div class="row" v-if="$parent.page.project_owner">
                        <span class="headline">{{$t('common.projectowner')}}</span>
                        <p class="value">{{$parent.page.project_owner}}</p>
                    </div>
                    <div class="row" v-if="$parent.page.project_management">
                        <span class="headline">{{$t('common.projectmanager')}}</span>
                        <p class="value">{{$parent.page.project_management}}</p>
                    </div>
                    <div class="row" v-if="$parent.page.grouping">
                        <span class="headline">{{$t('common.grouping')}}</span>
                        <p class="value">{{$parent.page.grouping}}</p>
                    </div>
                </div>
                <div class="footer">
                    <div class="gabarit">
                        <div class="row" v-if="$parent.page.work_period.start && $parent.page.work_period.end">
                            <span class="headline">{{$t('common.workperiod')}}</span>
                            <p class="value">{{$parent.page.work_period.start}} - {{$parent.page.work_period.end}}</p>
                        </div>
                    </div>
                </div>
            </template>
        </FollowUp>
    </div>
</template>

<script>
import MixinSlidable from '@/components/MixinSlidable'
import Slider from '@/components/Slider/index'
import FollowUp from '@/components/Slider/FollowUp'
import Cta from '@/components/Cta'
import Ui from '@/components/Slider/Ui'
export default {
    mixins: [MixinSlidable],
    components: {
        Slider,
        FollowUp,
        Cta,
        Ui
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    computed: {
        country() {
            return this.$parent.page ? this.$parent.page.related_posts.find(_ => _.type === 'country') : false
        },
        document() {
            return this.$parent.page.document ? this.$parent.page.document.url : false
        },
        location() {
            return this.$parent.page.locationdetails ? this.$parent.page.locationdetails : false
        },
        count() {
            return this.layout.slides.length
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.container
    display: flex
    @media print
        display: block
.content
    flex: 1
    display: flex
    flex-direction: column
.value
    margin-top: .15em
.context-decorator
    position: absolute
    left: 0
    top: 0
    right: 0
    bottom: 0
    pointer-events: none
    @include media-breakpoint-down($lg)
        display: none
.context-view
    height: 500%
    position: relative
    overflow: hidden
    z-index: 1

.context-headline
    position: absolute
    left: 0

    font-size: 8.3333333333vw
    color: white
    font-weight: 500
    top: 0
    margin-left: 18%
    z-index: 0
    transform: translateY(31%) translateX(-50%) rotate(-90deg)

    @include media-breakpoint-up($xxl)
        font-size: 160px
    @include media-breakpoint-down($hd)
        font-size: 100px
    @include media-breakpoint-down($sm)
        font-size: 10vw
    &.dark
        color: #ff2b2a
.ui
    padding: 0 8.25% 0 36%
    @include media-breakpoint-down($lg)
        padding-left: 9.25%
        padding-right: 9.25%
@media print
    .project-slider,
    /deep/ .ui
        display: none
</style>
